import React from "react";

import * as mainStyles from "../../../styles/layout/main.module.scss";

const BottomLayout = ({ children, ...props }) => {

  return (
    <>
      <div className={mainStyles.bottomTemplate}>
        {children}
      </div>
    </>
  );
};

export default BottomLayout;
